// extracted by mini-css-extract-plugin
module.exports = {"name":"DeliveryFormShippingOptionMethodLabel_name__gslo4","description":"DeliveryFormShippingOptionMethodLabel_description__xPG5G"};